import { useState } from "react";
import FormSubmitButton from "./FormSubmitButton";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { setNotifTo } from "../../store";
import { addMessage } from "../../remote/firebase";

function ContactForm({ className }) {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const clear = () => {
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        addMessage(name, email, message);
        dispatch(
          setNotifTo(
            "It's nice to hear from you! I'll try my best to respond within 24hrs. Thanks :-)"
          )
        );
        clear();
      }}
      className={classNames("flex flex-col w-[460px] h-[460px]", className)}
    >
      <div className="flex flex-col form-section w-4/6">
        <label htmlFor="name" className="form-label">
          Name
        </label>
        <input
          type="text"
          name="name"
          className="form-input"
          value={name}
          required
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
      </div>
      <div className="flex flex-col form-section w-4/6">
        <label htmlFor="email" className="form-label">
          Email
        </label>
        <input
          type="email"
          name="email"
          className="form-input"
          value={email}
          required
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
      </div>
      <div className="flex flex-col form-section grow">
        <label htmlFor="message" className="form-label">
          Message
        </label>
        <textarea
          name="message"
          className="form-input grow"
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          placeholder="Hello there!"
        />
      </div>
      <div className="mt-5 flex flex-row items-center">
        <FormSubmitButton />
        <button
          type="button"
          className="ml-3 form-clear"
          onClick={(e) => {
            e.stopPropagation();
            clear();
          }}
        >
          Clear Form
        </button>
      </div>
    </form>
  );
}

export default ContactForm;
